import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { devtoolsOptionsFactory } from '@ngxs/devtools-plugin/src/devtools.module';

@Component({
  selector: 'unh-filter-bottomsheet-option-list',
  templateUrl: './filter-bottomsheet-option-list.component.html',
  styleUrls: ['./filter-bottomsheet-option-list.component.scss'],
})
export class FilterBottomsheetOptionListComponent implements OnInit {
  @Input() set options(options) {
    this.allOptions = options;
  }
  @Input() identifier: string;
  @Input() selectedOrderBy: string;
  @Input() radio: boolean;
  @Input() listTitle: string;
  @Input() showInputSearch?: false;
  @Input() isShowContinueButton?: false;
  @Input() isRadio?: boolean;
  @Output() optionSelected = new EventEmitter();
  @Output() updateFilterOnCheck = new EventEmitter();
  @Output() searchTypedText = new EventEmitter();
  @Output() applyFilter = new EventEmitter();
  @Output() orderbyChanged = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();

  get options() {
    return this.allOptions;
  }

  allOptions: any[];
  filteredOptions: any[];
  selectedOptionsToRemove = [];
  searchText = new FormControl();
  placeholderInput: string;
  isOptionsContainsIcons: boolean;

  ngOnInit(): void {
    this.searchText.patchValue('');
    this.placeholderInput = `Buscar ${this.listTitle.toLowerCase()}...`;
    this.allOptions = [...this.options];
    this.filteredOptions = [...this.allOptions];
    this.handleFilterOptionsByText();
  }

  updateSelecteds(received) {
    const checkedOption = this.allOptions.find(
      (item) => item.title === received.title
    );
    checkedOption.value = !checkedOption.value;
    checkedOption.selected = !checkedOption.value;
    if (!this.isShowContinueButton) {
      return this.applyFilter.emit(
        this.allOptions.filter((item) => item.value)
      );
    }
  }

  handleFilterOptionsByText(): void {
    this.searchText.valueChanges.subscribe((value) => {
      this.filteredOptions = this.allOptions.filter((option) =>
        option.title.toLowerCase().includes(value.toLowerCase())
      );
      this.selectedOptionsToRemove = [];
    });
  }

  handleApplyFilter(): void {
    this.applyFilter.emit(this.allOptions?.filter((item) => item?.value));
    this.close.emit();
  }

  changeOrderBy(option) {
    this.orderbyChanged.emit(option);
  }
}
